import { render, staticRenderFns } from "./QuestionContainer.vue?vue&type=template&id=72242bef&scoped=true"
import script from "./QuestionContainer.vue?vue&type=script&lang=js"
export * from "./QuestionContainer.vue?vue&type=script&lang=js"
import style0 from "./QuestionContainer.vue?vue&type=style&index=0&id=72242bef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72242bef",
  null
  
)

export default component.exports